export const HaveQuestions = () => {
    return <section className="py-5 bg-charade">
        <div className="container">
            <div className="d-flex justify-content-center align-items-center row">
                <div
                    data-aos="fade-up"
                    className="text-center col aos-init aos-animate"
                >
                    <p className="text-uppercase fs-18 fw-500 text-main-green">
                        <svg
                            stroke="currentColor"
                            fill="currentColor"
                            strokeWidth={0}
                            viewBox="0 0 16 16"
                            className="me-1"
                            height={8}
                            width={8}
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <circle cx={8} cy={8} r={8} />
                        </svg>
                        HAVE QUESTIONS?
                    </p>
                    <h2 className="text-white fw-600 display-6 mb-3 mb-md-4">
                        Connect with us &amp; get your answers
                    </h2>
                </div>
                
            </div>
            <div className="d-flex justify-content-center align-items-strech pt-5 row">
                <div
                    data-aos="fade-up"
                    className="text-center text-md-start col-lg-5 col-md-12 col-12 aos-init aos-animate"
                >
                    <p className="fs-26 fs-sm-22 fw-500 text-white mb-5">
                        Curiosity is one of the greatest secrets of Success.
                    </p>
                    <ul className="list-unstyled fs-20 fs-sm-18 fw-500 text-white text-start">
                        <li className="d-flex justify-content-start mt-3">
                            <svg
                                stroke="currentColor"
                                fill="currentColor"
                                strokeWidth={0}
                                viewBox="0 0 16 16"
                                className="text-main-gold mt-2 me-3"
                                height="1em"
                                width="1em"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path d="M3 14.5A1.5 1.5 0 0 1 1.5 13V3A1.5 1.5 0 0 1 3 1.5h8a.5.5 0 0 1 0 1H3a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V8a.5.5 0 0 1 1 0v5a1.5 1.5 0 0 1-1.5 1.5H3z" />
                                <path d="m8.354 10.354 7-7a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0z" />
                            </svg>
                            Personalised discussion to clear all your queries.
                        </li>
                        <li className="d-flex justify-content-start mt-3">
                            <svg
                                stroke="currentColor"
                                fill="currentColor"
                                strokeWidth={0}
                                viewBox="0 0 16 16"
                                className="text-main-gold mt-2 me-3"
                                height="1em"
                                width="1em"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path d="M3 14.5A1.5 1.5 0 0 1 1.5 13V3A1.5 1.5 0 0 1 3 1.5h8a.5.5 0 0 1 0 1H3a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V8a.5.5 0 0 1 1 0v5a1.5 1.5 0 0 1-1.5 1.5H3z" />
                                <path d="m8.354 10.354 7-7a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0z" />
                            </svg>
                            Looking for quick answers? Chat with us now.
                        </li>
                        <li className="d-flex justify-content-start mt-3">
                            <svg
                                stroke="currentColor"
                                fill="currentColor"
                                strokeWidth={0}
                                viewBox="0 0 16 16"
                                className="text-main-gold mt-2 me-3"
                                height="1em"
                                width="1em"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path d="M3 14.5A1.5 1.5 0 0 1 1.5 13V3A1.5 1.5 0 0 1 3 1.5h8a.5.5 0 0 1 0 1H3a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V8a.5.5 0 0 1 1 0v5a1.5 1.5 0 0 1-1.5 1.5H3z" />
                                <path d="m8.354 10.354 7-7a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0z" />
                            </svg>
                            Learn and grow with your peers.
                        </li>
                    </ul>
                </div>
                <div className="text-center d-flex justify-content-md-end justify-content-center align-items-center col-lg-7 col-md-12 col-12">
                    <div className="mt-5 mt-lg-0 pe-md-5 me-md-5 row">
                        <div
                            data-aos="fade-up"
                            className="d-grid gap-4 col-12 aos-init aos-animate"
                        >
                            <div>
                                <a href="\contact-us">
                                    <button
                                        type="button"
                                        className="px-3 px-md-5 py-3 w-100 btn btn-dark btn-lg"
                                    >
                                        <img
                                            src="https://cms.growpital.com/uploads/call_center_svgrepo_com_1_1_b386393b80.svg"
                                            className="img-fluid me-3 bg-yellow"
                                            alt=""
                                            style={{ width: "3rem" }}
                                        />
                                        Schedule a call
                                    </button>
                                </a>
                            </div>
                            {/* <div>
                                <button
                                    type="button"
                                    className="px-3 px-md-5 py-3 w-100 btn btn-dark btn-lg"
                                >
                                    <img
                                        src="https://cms.growpital.com/uploads/icons8_chat_room_96_a299aacfb3.png"
                                        className="img-fluid me-3"
                                        alt=""
                                        style={{ width: "3rem" }}
                                    />
                                    Chat
                                </button>
                            </div> */}
                            {/* <div>
                                <a href="#">
                                    <button
                                        type="button"
                                        className="px-3 px-md-5 py-3 btn btn-dark btn-lg"
                                    >
                                        <img
                                            src="https://cms.growpital.com/uploads/kisspng_telegram_logo_computer_icons_scalable_vector_graph_png_telegram_transparent_5ab08470747435_671490841521517680477_6b03ae449c.png"
                                            className="img-fluid me-3"
                                            alt=""
                                            style={{ maxWidth: 50 }}
                                        />
                                        Community
                                    </button>
                                </a>
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

}